import { apiClient } from "./client";
import type { SlumbrNotification } from "../types/notification";

export interface CreateNotificationPayload {
  userId: string;
  appId: string;
  type: string;
  title: string;
  body: string;
  link?: string;
  metadata?: Record<string, unknown>;
}

export async function listNotifications(): Promise<SlumbrNotification[]> {
  return apiClient.get<SlumbrNotification[]>("/api/notifications");
}

export async function createNotification(
  payload: CreateNotificationPayload
): Promise<SlumbrNotification> {
  return apiClient.post<SlumbrNotification>("/api/notifications", payload);
}

export async function markNotificationAsRead(
  id: string
): Promise<{ success: true }> {
  return apiClient.post<{ success: true }>(`/api/notifications/${id}/read`, {});
}

export async function markAllNotificationsAsRead(): Promise<{ updated: number }> {
  return apiClient.post<{ updated: number }>("/api/notifications/read-all", {});
}
